import React, { useContext } from "react";
import { ServiceContext } from "../../hooks/context/ServiceContext";
import { useNavigate } from "react-router-dom";

function ChooseService() {
  const { setService } = useContext(ServiceContext);
  const navigate = useNavigate();
  return (
    <div className="h-screen w-full flex relative">
      <div className="left h-full w-full bg-primary hidden md:flex items-center justify-center flex-col ">
        <img src="/logo/division1.png" className="fixed top-0 right-0" alt="" />
        <img src="/logo/division2.png" className="fixed bottom-0 left-0" alt="" />
        <h4 className="text-white text-3xl font-bold mb-10">Select Service</h4>
        <div className="grid grid-cols-2 gap-5">
          <div
            className="authBox w-[30rem] h-[20rem] p-10 cursor-pointer bg-white rounded-xl flex items-center justify-center"
            onClick={() => {
              setService("glo");
              window.location.href=("/login");
            }}
          >
            <img src="./logo/glo.png" alt="" />
          </div>
          <div
            className="authBox w-[30rem] h-[20rem] p-10 cursor-pointer bg-white rounded-xl flex items-center justify-center"
            onClick={() => {
              setService("mtn");
              window.location.href=("/login");
            }}
          >
            <img src="./logo/mtn.png" alt="" />
          </div>
        </div>

        <div className="mt-40 container w-full flex justify-end">
          {" "}
          <img src="./logo/logo.svg" className="h-32 w-32 object-contain" alt="" />
        </div>
      </div>
    </div>
  );
}

export default ChooseService;
